// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/tailplane-stall.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/tailplane-stall/tailplane-stall.js';

mount([g0]);
